import React, { useState } from 'react';
import styled from 'styled-components';
import meetIcon from './images/meet.svg';
import upIcon from './images/arrow-up.svg';
import downIcon from './images/arrow-down.svg';

type MeetAndGreetProps = {
    message: string;
};

export const MeetAndGreet = (props: MeetAndGreetProps) => {
    const [expanded, setExpanded] = useState(false);
    const [elipsis, setElipsis] = useState(false);
    const ref = React.createRef<HTMLDivElement>();

    React.useLayoutEffect(() => {
        if (ref.current && ref.current.clientHeight < ref.current.scrollHeight) {
            setElipsis(true);
        }
    }, [ref]);

    if (props === null || props.message === '') return null;

    const onClick = () => {
        setExpanded(!expanded);
    };

    const arrowIcon = expanded ? upIcon : downIcon;
    return (
        <MettAndGreetContainer className='MeetAndGreet'>
            <MeetIconContainer>
                <img src={meetIcon} alt='Icon' style={{ width: '24px' }} />
            </MeetIconContainer>
            <MessageContainer ref={ref} onClick={onClick} expanded={expanded}>
                {props.message}
            </MessageContainer>
            {elipsis && (
                <ArrowIconContainer onClick={onClick}>
                    <img src={arrowIcon} alt='Icon' style={{ width: '16px' }} />
                </ArrowIconContainer>
            )}
        </MettAndGreetContainer>
    );
};

const MettAndGreetContainer = styled.div`
    background-color: #ebf4ff;
    display: flex;
    flex-direction: row;
    padding: 24px 24px;
    align-items: center;
`;

const MeetIconContainer = styled.div`
    padding: 5px 10px 0 0;
    width: 24px;
    margin-right: 10px;
`;
const ArrowIconContainer = styled.div`
    padding: 5px 10px 0 0;
    width: 16px;
    margin-right: 10px;
`;

const MessageContainer = styled.div`
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.57;
    letter-spacing: normal;
    font-family: 'Graphik LCG', sans-serif;
    color: #263238;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 24px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    transition: -webkit-box-orient 0.5s ease;
    -webkit-box-orient: ${(props) => (props.expanded ? 'horizontal' : 'vertical')};
`;
